import styled from 'styled-components';

export const FilterWrapper = styled.div`
display: grid;
grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* Adjust 300px to the desired minimum width */
gap: 15px; /* Adjust for spacing between filters */
margin-top: 2em;
`